import React, { FC } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';
import defaultHeader from './assets/header';

/**
 * Load variants in this way to avoid all being included in the webpack bundle
 */
const dynamicComponents: Record<string, React.ComponentType> = {
    defaultHeader // load the default non dynamically as it is most frequent
};

const LiveRampComponent = dynamic(
    () => import('./assets/liveramp-consent-management-platform')
);

const Header: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);

    const variantName = 'defaultHeader';

    const HeaderComponent = dynamicComponents[variantName];

    return (
        <>
            {_useLiveRamp && (
                <Head>
                    <LiveRampComponent />
                </Head>
            )}
            <HeaderComponent />
        </>
    );
};

export default withOptimizely(Header);
